export const ru = {
    'gender-and-age': 'пол: {gender}, возраст: {age}',
    'on-condition': 'по условию «{condition}»'
};
